import { Layer } from '@deck.gl/core';
import { getMonitorStatusColor } from '@fe/core';
import { IFlightItem } from '../flights/types';
import { iconPixelSize } from '../IconType';
import { DeckLayerCreator } from './deck-layer-creator';
import { DeckOverlayPlugin } from './deck-overlay-plugin';
import { AnimatedScatterplotLayer } from './layers/scatterplot/animated-scatterplot-layer';
import { HidableScatterplotLayer } from './layers/scatterplot/hidable-scatterplot-layer';

export class DeckMonitorStatus extends DeckLayerCreator {
    constructor(plugin: DeckOverlayPlugin) {
        super(plugin);
    }

    createLayers(data: IFlightItem[]): Layer[] {
        if (!this.props?.flights.active.visible && data.length > 0) {
            return [];
        }

        const { isMonitorStatus } = this.props!.flights.active;

        const monitorStatusProps: Partial<HidableScatterplotLayer<IFlightItem>['props']> = {
            data,
            visible: isMonitorStatus,
            pickable: false,
            wrapLongitude: true,
            radiusUnits: 'pixels',
            lineWidthUnits: 'pixels',
            radiusScale: this.getIconScale(),
            getRadius: (d) => iconPixelSize(d.iconType) / 2,
            getIsHidden: (d) => this.getIsHidden(d),
            getFillColor: (d) => getMonitorStatusColor(d.monitorStatus),
            getLineWidth: 1,
            stroked: false,
            updateTriggers: {
                all: [this.flightsVersion],
                getIsHidden: this.getIsHiddenUpdateTrigger,
            }
        };

        return [
            this.isCoastMode
                ? new AnimatedScatterplotLayer<IFlightItem>({
                      ...monitorStatusProps,
                      id: 'animated-monitor-status',
                      getId: (x) => x.id
                  })
                : new HidableScatterplotLayer<IFlightItem>({
                      ...monitorStatusProps,
                      id: 'monitor-status',
                      getPosition: (d) => this.getFlightPosition(d)
                  })
        ];
    }
}
